/* src/app/components/shared/model/hostedpayment-dialog/hostedpayment-dialog.component.scss */
.hosted_payment-Dialog .dialog-title {
  color: #FFFFFF;
  font-size: 21px;
}
.hosted_payment-Dialog .header {
  background-color: var(--theme-deafult);
}
.hosted_payment-Dialog .header-tab-action {
  background: rgba(0, 0, 0, 0.1490196078) !important;
  margin: 0px 5px;
  border-radius: 10px;
  color: #FFFFFF;
}
.hosted_payment-Dialog .mat-mdc-dialog-content {
  margin: 0px;
  padding: 23px 25px;
}
.hosted_payment-Dialog .mat-mdc-dialog-content .borderBox {
  border: 1px solid #e0e0e0;
}
.hosted_payment-Dialog .mat-mdc-dialog-content .p-15 {
  padding: 15px !important;
}
.hosted_payment-Dialog .mat-mdc-dialog-actions {
  margin: 0px;
  padding: 23px 25px;
}
.hosted_payment-Dialog .mat-mdc-dialog-actions .updateButton {
  background-color: var(--theme-deafult);
  color: #FFFFFF;
}
.c-1 {
  color: var(--theme-deafult);
}
::ng-deep .hosted_payment-Dialog .mat-mdc-dialog-container {
  margin: 0px;
  padding: 0px !important;
}
.material-icons.color_white {
  color: #ffffff;
}
.close-button {
  float: right;
  top: -24px;
  right: -24px;
}
.close-icon {
  transition: 1s ease-in-out;
  color: white;
}
.close-icon:hover {
  transform: rotate(180deg);
}
::ng-deep .hosted_payment-Dialog .close-button {
  float: right;
  top: -52px;
  right: -52px;
}
::ng-deep .hosted_payment-Dialog .mat-mdc-dialog-container {
  overflow: unset;
}
/*# sourceMappingURL=hostedpayment-dialog.component.css.map */
